import { v4 as uuid } from 'uuid';
import { TLS_ONLINE_CLIENT_ID } from '../constants/travelerDataConstants';
import { ABANDON_HOTEL_CATEGORY } from '../constants/lineOfBusinessConstants';

export const getPayloadForClearContext = (accountToken) => ({
  context: [{
    code: 'HOTEL_ABANDON',
    value: 'CLEAR',
  }],
  card: {
    cardNumber: accountToken,
    type: 'ENC_HIPED',
  },
});

export const formatDate = (date, locale = 'en-US') => new Date(date).toLocaleDateString(locale, {
  month: 'numeric',
  day: 'numeric',
  year: 'numeric',
  timeZone: 'UTC',
});

export const capitalize = (str) => str[0].toUpperCase() + str.slice(1);

export const isValidHotelDisplayDate = (hotelDate) => {
  const formattedCurrentDate = new Date(formatDate(Date.now()));
  formattedCurrentDate.setHours(+48);

  const formattedHotelDate = new Date(formatDate(hotelDate));

  return formattedCurrentDate.getTime() < formattedHotelDate.getTime();
};

export const hasValidAbandonCartData = (abandonCartData) => Object.keys(abandonCartData).length > 0
    && abandonCartData?.category === ABANDON_HOTEL_CATEGORY
    && abandonCartData?.tripStartDate
    && abandonCartData?.tripEndDate
    && abandonCartData?.hotelProductSelected
    && isValidHotelDisplayDate(abandonCartData?.tripStartDate);

export const getContextDetails = ({
  abandonCartData,
}) => Object
  .entries(abandonCartData)
  .map(([key, value]) => ({ code: capitalize(key), value }));

export const getPayloadForContextFeedbackLoop = ({
  abandonCartData, accountToken,
}) => ({
  eventType: 'GLOBAL_ONLINE_TLSONLINE_FEEDBACK',
  eventPayload: {
    channelName: TLS_ONLINE_CLIENT_ID,
    intentCode: 'Abandon Cart Feedback',
    intentDescription: 'Abandon Cart Feedback',
    trackingId: uuid(),
    details: [
      {
        code: 'ContextDisposition',
        value: 'Clicked',
      },
      {
        code: 'ClickedTime',
        value: new Date().toISOString(),
      },
      ...getContextDetails({ abandonCartData }),
    ],
  },
  eventSource: 'TLSOnline',
  eventTransferDate: new Date().toISOString(),
  card: accountToken,
});
